import React from 'react'
import { Grid, Typography, Container, Box, Paper } from '@mui/material'
import { TicketInfo } from '../../../interfaces/PickingValidate/TicketInfo'
import { useStyles } from './styles'

interface PickingValidateTicketProps {
  ticketInfo: TicketInfo
}

export const PickingValidateTicket: React.FC<PickingValidateTicketProps> = ({
  ticketInfo
}) => {
  const classes = useStyles()
  const hasPendingZones: boolean = ticketInfo.pendingZones !== ''
  return (
    <Container maxWidth='xl'>
      <Paper elevation={0}>
        <Box border={1} borderRadius={10}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm container>
              <Grid item xs container direction='column' spacing={2}>
                <Grid item xs>
                  <Box border={1} borderRadius={10} style={{ margin: '15px' }}>
                    <Typography gutterBottom className={classes.ticketHeader}>
                      {`OT ${ticketInfo.workOrderId}`}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs>
                  <Typography
                    gutterBottom
                    className={classes.ticketHeader}
                    align='center'
                  >
                    {ticketInfo.zone}
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs
                  container
                  direction='row'
                  alignItems='center'
                  spacing={2}
                >
                  <Grid item xs={hasPendingZones ? 6 : 12}>
                    <Typography
                      gutterBottom
                      className={classes.ticketOrder}
                      align='center'
                    >
                      {ticketInfo.pickingOrder}
                    </Typography>
                  </Grid>
                  {hasPendingZones && (
                    <Grid item xs={6}>
                      <Typography
                        gutterBottom
                        className={classes.ticketOrder}
                        align='center'
                      >
                        {ticketInfo.pendingZones}
                      </Typography>
                    </Grid>
                  )}
                </Grid>

                <Grid item xs>
                  <Grid item xs container direction='row' spacing={2}>
                    <Grid item xs={6}>
                      <Typography gutterBottom className={classes.ticketHeader}>
                        {`RP ${ticketInfo.pickingRouteId}`}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography gutterBottom className={classes.ticketHeader}>
                        {ticketInfo.courierDeliveryDateString}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Container>
  )
}
